var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF9C3B77-B027-46AF-83D3-E665D4B6B7B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "H&W-Val-Prop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MPP1-ToolTip-ValProp-Copy",
    transform: "translate(-157.000000, -262.000000)",
    fill: "#515151",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "val-prop-area-copy",
    transform: "translate(20.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF059",
    transform: "translate(137.249999, 4.250033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74998152,0 C3.4700845,0 0,3.47133572 0,7.74998152 C0,12.0311298 3.4700845,15.499963 7.74998152,15.499963 C12.0298785,15.499963 15.499963,12.0311298 15.499963,7.74998152 C15.499963,3.47133572 12.0298785,0 7.74998152,0 Z M7.74998152,13.9999666 C4.29585768,13.9999666 1.49999642,11.205265 1.49999642,7.74998152 C1.49999642,4.29701734 4.29597975,1.49999642 7.74998152,1.49999642 C11.2028236,1.49999642 13.9999666,4.29594923 13.9999666,7.74998152 C13.9999666,11.2040443 11.205265,13.9999666 7.74998152,13.9999666 Z M11.1013529,6.02497953 C11.1013529,4.44698036 9.46451601,3.24999225 7.93104188,3.24999225 C6.46687301,3.24999225 5.52641505,3.85909114 4.78807452,4.94325604 C4.67537337,5.1088135 4.71110937,5.33360545 4.87071593,5.45460736 L5.74019017,6.11393806 C5.90287899,6.2372593 6.1342322,6.20753525 6.26100192,6.04756249 C6.73127668,5.45405804 7.06580957,5.11101076 7.79044773,5.11101076 C8.34623254,5.11101076 9.03370039,5.46873696 9.03370039,6.00767611 C9.03370039,6.41511532 8.69736696,6.62437385 8.14857066,6.93202083 C7.50861857,7.29081514 6.66172728,7.73734728 6.66172728,8.85437952 L6.66172728,9.12497824 C6.66172728,9.33207004 6.8296346,9.49997735 7.03672639,9.49997735 L8.46320614,9.49997735 C8.67029793,9.49997735 8.83820525,9.33207004 8.83820525,9.12497824 L8.83820525,8.92695015 C8.83820525,8.15259897 11.1013529,8.12034197 11.1013529,6.02497953 Z M9.06247839,11.2499732 C9.06247839,10.5262505 8.47370416,9.93747631 7.74998152,9.93747631 C7.02625888,9.93747631 6.43748465,10.5262505 6.43748465,11.2499732 C6.43748465,11.9736958 7.02625888,12.56247 7.74998152,12.56247 C8.47370416,12.56247 9.06247839,11.9736958 9.06247839,11.2499732 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipIcon);
export default __webpack_public_path__ + "static/media/toolTipIcon.bb7c2fbcd94a2575c99feb4dbd575695.svg";
export { ForwardRef as ReactComponent };